import React from "react";
import { GenericDetailsModal, SearchBar, Table } from "@components";
import { useAllLocations } from "@api";
import { useGetLocations } from "./useGetLocations";
import { useManageLocation } from "./useManageLocation";
import { LocationsSideBar } from "./LocationsSideBar";
import { useZipSearch } from "@/pages/Admin/Locations/useZipSearch";
import { getLocationDetails } from "pages/Admin/Locations/getLocationDetails";
import { STRING } from "@constants";
import { LocationRead } from "@types";

const T = STRING.LOCATION_DETAILS;

export function Locations() {
  const { data, loading: allLoading } = useAllLocations();

  const {
    locations,
    toggleSideBar,
    isSideBarOpen,
    selectCouponsToEdit,
    isDetailsModalOpen,
    handleCloseDetailsModal,
    handleRowClick,
    setLocations,
  } = useManageLocation();

  const { columns } = useGetLocations({ onEdit: selectCouponsToEdit });

  const {
    zip,
    zipError,
    results: filteredLocations,
    loading: searchLoading,
    onChange: handleZipChange,
    onSearch: handleSearch,
    onClear: handleClear,
  } = useZipSearch();

  const { sections } = getLocationDetails(locations);

  const handleLocationUpdated = (updatedLocation: LocationRead) => {
    setLocations(updatedLocation);
  };

  return (
    <div className="overflow-hidden">
      <LocationsSideBar
        show={isSideBarOpen}
        editValues={locations}
        onClose={toggleSideBar}
        onLocationUpdated={handleLocationUpdated}
      />

      <GenericDetailsModal
        visible={isDetailsModalOpen}
        onHide={handleCloseDetailsModal}
        sections={sections}
        header={T.MODAL_HEADER}
        noDataText={T.NO_DATA}
      />

      <SearchBar
        label="Zip Code"
        value={zip}
        onChange={handleZipChange}
        onSearch={handleSearch}
        onClear={handleClear}
        loading={searchLoading}
      />

      {zipError && <small className="text-red-500 ml-1">{zipError}</small>}

      <Table
        columns={columns}
        data={filteredLocations || data}
        title="Locations"
        onRowClicked={handleRowClick}
        loading={searchLoading || allLoading}
      />
    </div>
  );
}
